import { Event } from '@adminModels';
import { CreateEventData, EventsQueryParams, UpdateEventData } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { ButtonType, UserRole } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as EventsActions from './events.actions';
import * as EventsSelectors from './events.selectors';

@Injectable({
  providedIn: 'root',
})
export class EventsFacade {
  private store = inject(Store);

  events$ = this.store.select(EventsSelectors.selectAllEvents);
  loading$ = this.store.select(EventsSelectors.selectEventsLoading);
  error$ = this.store.select(EventsSelectors.selectEventsError);
  selectedEvent$ = this.store.select(EventsSelectors.selectSelectedEvent);
  pagination$ = this.store.select(EventsSelectors.selectEventsPagination);

  loadEvents(params?: EventsQueryParams): void {
    this.store.dispatch(EventsActions.loadEvents({ params }));
  }

  loadEventById(id: string): void {
    this.store.dispatch(EventsActions.loadEventById({ id }));
  }

  createEvent(eventData: CreateEventData): void {
    this.store.dispatch(EventsActions.createEvent({ eventData }));
  }

  updateEvent(id: string, eventData: UpdateEventData): void {
    this.store.dispatch(EventsActions.updateEvent({ id, eventData }));
  }

  deleteEvent(id: string): void {
    this.store.dispatch(EventsActions.deleteEvent({ id }));
  }

  uploadTitleImage(id: string, file: File): void {
    this.store.dispatch(EventsActions.uploadTitleImage({ id, file }));
  }

  uploadThumbnail(id: string, file: File): void {
    this.store.dispatch(EventsActions.uploadThumbnail({ id, file }));
  }

  deleteTitleImage(id: string): void {
    this.store.dispatch(EventsActions.deleteTitleImage({ id }));
  }

  deleteThumbnail(id: string): void {
    this.store.dispatch(EventsActions.deleteThumbnail({ id }));
  }

  selectEvent(event: Event | null): void {
    this.store.dispatch(EventsActions.selectEvent({ event }));
  }

  canManageEvents(userRole: UserRole): boolean {
    return userRole === UserRole.Owner ||
      userRole === UserRole.Admin ||
      userRole === UserRole.EventAdmin;
  }

  getButtonTypeDisplayName(buttonType: ButtonType): string {
    switch (buttonType) {
      case ButtonType.Register:
        return 'Register';
      case ButtonType.Link:
        return 'External Link';
      case ButtonType.MoreInfo:
        return 'More Info';
      default:
        return buttonType;
    }
  }
}
